<template>
  <div>
    <ui-spinner v-if="loading.view"></ui-spinner>
    <ui-card v-else nested forceTitle>
      <div class="row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="">Tipo:</label>
            <InputSelect
              v-model="form.tipo"
              :options="containers.tipos"
              :reduce="opt => opt.value"
              :clearable="false"
            ></InputSelect>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="">Estado:</label>
            <InputSelect
              v-model="form.estado"
              :options="containers.estados"
              :reduce="opt => opt.value"
              :clearable="false"
            ></InputSelect>
          </div>
        </div>
      </div>
      <button
        class="btn btn-sm btn-secondary"
        @click="containers.showModalUsuarioTipos = true"
      >
        Tipos de usuario
      </button>
      <router-link
        :to="{ name: 'mantenimiento.usuario.nuevo' }"
        class="btn btn-sm btn-primary ml-2"
      >
        Agregar Usuario
      </router-link>
      <hr class="border-0" />
      <div class="table-responsive">
        <table class="table table-sm table-hover table-bordered">
          <thead class="table-secondary">
            <tr class="text-center align-middle">
              <th style="width: 80px"></th>
              <th>Nombre</th>
              <th>Código</th>
              <th>Tipo</th>
              <th>Cargo</th>
              <th>Teléfono</th>
              <th>Estado</th>
              <th>UC</th>
              <th>UM</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in usuariosFiltrados"
              :key="item.idPersona"
              class="text-center align-middle"
            >
              <td class="actions">
                <router-link
                  :to="{
                    name: 'mantenimiento.usuario',
                    params: { uuid: item.uuid }
                  }"
                  class="btn btn-xs btn-icon btn-light-warning"
                >
                  <span class="fa fa-fw fa-pen"></span>
                </router-link>
                <button
                  class="ml-2 btn btn-xs btn-icon btn-light-danger"
                  @click="disableUser(item)"
                >
                  <i class="fa fa-fw fa-trash"></i>
                </button>
              </td>
              <td>
                {{ item.nombre }}
                {{ item.apPaterno }}
                {{ item.apMaterno }}
              </td>
              <td>
                {{ item.codigo }}
              </td>
              <td>
                {{ item.tipo }}
              </td>
              <td>
                {{ item.cargo }}
              </td>
              <td>
                {{ item.telefono1 }}
              </td>
              <td>
                {{ item.estado }}
              </td>
              <td>{{ item.usuarioCreador }}</td>
              <td>{{ item.usuarioModif }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ui-card>
    <ModalUsuarioTipos
      v-if="containers.showModalUsuarioTipos"
      :show="containers.showModalUsuarioTipos"
      @close="containers.showModalUsuarioTipos = false"
    />
  </div>
</template>
<script>
import InputSelect from "../../../modules/shared/components/InputSelect.vue";
const MyTable = () => import("@/components/MyTable");
import ModalUsuarioTipos from "@/modals/UsuarioTipos.vue";

export default {
  components: {
    ModalUsuarioTipos,
    MyTable,
    InputSelect
  },
  data: () => ({
    form: {
      tipo: "",
      estado: ""
    },
    loading: {
      view: true
    },
    containers: {
      usuarios: [],
      tipos: [],
      estados: [],
      showModalUsuarioTipos: false
    }
  }),

  async created() {
    this.fetchPage();
  },
  computed: {
    usuariosFiltrados() {
      const vm = this;

      return vm.containers.usuarios.filter(item => {
        let coincide = false;

        coincide = !vm.form.tipo ? true : vm.form.tipo === item.tipo;
        coincide =
          coincide && (!vm.form.estado ? true : vm.form.estado === item.estado);

        return coincide;
      });
    }
  },

  methods: {
    async fetchPage() {
      this.loading.view = true;
      const response = await this.axios.get("/mantenimiento/usuarios");
      const usuarios = response.data.content;
      let tipos = {};
      let estados = {};

      usuarios.forEach(item => {
        if (item.tipo) {
          if (typeof tipos[item.tipo] == "undefined") {
            tipos[item.tipo] = {
              label: item.tipo,
              value: item.tipo
            };
          }
        }

        if (item.estado) {
          if (typeof tipos[item.estado] == "undefined") {
            estados[item.estado] = {
              label: item.estado,
              value: item.estado
            };
          }
        }
      });

      tipos = Object.values(tipos);
      tipos.unshift({
        value: "",
        label: "TODOS"
      });

      estados = Object.values(estados);
      estados.unshift({
        value: "",
        label: "TODOS"
      });

      this.containers.tipos = tipos;
      this.containers.estados = estados;
      this.containers.usuarios = usuarios;
      this.loading.view = false;
    },
    async disableUser(user) {
      const { isConfirmed } = await this.$swal.fire({
        html: "Confirmar acción",
        icon: "warning",
        showCancelButton: true
      });
      if (!isConfirmed) return;

      try {
        const response = await this.axios.put(`/usuarios/${user.idPersona}/estado`);
        this.$swal.fire("", response.data.message, 'success');
      } finally {
        this.fetchPage();
      }
    }
  }
};
</script>
